import { render, staticRenderFns } from "./CompanySurvey2022.vue?vue&type=template&id=29abaac4&"
import script from "./CompanySurvey2022.vue?vue&type=script&lang=js&"
export * from "./CompanySurvey2022.vue?vue&type=script&lang=js&"
import style0 from "./CompanySurvey2022.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports